import React from "react";
import Chart from "react-apexcharts";
import Select from "react-select";
import SkeletonCard from "./SkeletonCard";

// const DonutChart = ({ isLoading }) => {
//   const series = [88];

//   const options = {
//     chart: { type: "donut" },
//     colors: ["#FF641B"],
//     legend: { show: false },
//     plotOptions: {
//       pie: {
//         donut: {
//           labels: {
//             show: true,
//             name: { show: false },
//             value: {
//               show: true,
//               fontSize: "16px",
//               fontWeight: 600,
//               color: "#333",
//               formatter: (val) => val,
//             },
//             total: {
//               show: true,
//               label: "Total",
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#999",
//               formatter: () => series.reduce((a, b) => a + b, 0),
//             },
//           },
//         },
//       },
//     },
//     labels: ["C 1"],
//     responsive: [
//       {
//         breakpoint: 400,
//         options: {
//           chart: { width: 200 },
//         },
//       },
//     ],
//   };

//   const dropdownOptions = [
//     { value: "key_events", label: "Key Events" },
//     { value: "other_events", label: "Other Events" },
//   ];

//   return (
//     <div
//       className="bg-white border rounded shadow-sm p-3"
//       style={{ height: "100%" }}
//     >
//       {isLoading ? (
//         <SkeletonCard count={9} height={20} />
//       ) : (
//         <>
//           <div className="d-flex align-items-center mb-3">
//           <h5>Key Events By Platform </h5>
//             {/* <div style={{ minWidth: "140px" }}>
//               <Select
//                 options={dropdownOptions}
//                 defaultValue={dropdownOptions[0]}
//               />
//             </div>
//             <span
//               style={{ fontSize: "0.85rem", color: "#666", marginLeft: "4px" }}
//             >
//               by Platform
//             </span> */}
//           </div>

//           <div
//             id="chart"
//             className="d-flex justify-content-center align-items-center"
//             style={{ minHeight: "280px", width: "100%" }}
//           >
//             <Chart
//               options={options}
//               series={series}
//               type="donut"
//               height={280}
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );
// };
const DonutChart = ({ isLoading, series = [], labels = [] }) => {
  const options = {
    chart: { type: "donut" },
    colors: ["#FF641B", "#28a745", "#007bff", "#ffc107", "#6f42c1"],
    labels: labels,
    legend: { show: true, position: "bottom" },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            value: {
              show: true,
              fontSize: "16px",
              fontWeight: 600,
              color: "#333",
              formatter: (val) => val,
            },
            total: {
              show: true,
              label: "Total",
              fontSize: "14px",
              fontWeight: 500,
              color: "#999",
              formatter: () => series.reduce((a, b) => a + b, 0),
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 400,
        options: {
          chart: { width: 200 },
        },
      },
    ],
  };

  return (
    <div
      className="bg-white border rounded shadow-sm p-3"
      style={{ height: "100%" }}
    >
      {isLoading ? (
        <SkeletonCard count={9} height={20} />
      ) : (
        <>
          <div className="d-flex align-items-center mb-3">
            <h5>Key Events By Platform</h5>
          </div>

          <div
            id="chart"
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "280px", width: "100%" }}
          >
            <Chart
              options={options}
              series={series}
              type="donut"
              height={280}
            />
          </div>
        </>
      )}
    </div>
  );
};
export default DonutChart;